import React from 'react';
import {Link} from 'react-router-dom';

export const Banner = ({catalogResult}) => {
  return (
    <div className="banner">
      <div className="banner-img" style={{zIndex: 1}}>
        <img
          src={catalogResult?.banner[0]}
          alt="banner"
          style={{objectFit: 'cover'}}
        />
      </div>
      <div className="d-flex gap-10 items-center" style={{zIndex: 2}}>
        <div className="banner-left" style={{zIndex: 2}}>
          <div className="banner-icon">
            <img src={catalogResult?.icon[0]} alt="catalogIcon" />
            {/* <svg
              width="54"
              height="35"
              viewBox="0 0 54 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.62185 2.10262C2.19651 1.36893 3.13418 0.971935 4.05869 1.00155C12.9429 1.00155 21.8272 1.00374 30.7115 1.00155C31.3015 0.999352 31.9156 1.01361 32.4585 1.27243C33.4543 1.73084 34.0969 2.8045 34.1167 3.89022C34.1474 5.29178 34.1134 6.69335 34.1211 8.09491C36.9374 8.08395 39.7547 8.09821 42.571 8.09601C43.6436 8.08395 44.7216 8.53907 45.4071 9.37365C47.6268 12.02 49.841 14.6696 52.0585 17.3181C52.4193 17.7534 52.7088 18.2568 52.8503 18.8084C52.9983 19.3425 52.9863 19.9018 52.9852 20.4513C52.9885 22.4231 52.972 24.3961 52.9994 26.3679C53.0082 27.0468 52.9183 27.7519 52.5553 28.3398C52.0771 29.1469 51.1844 29.7161 50.238 29.7402C49.4703 29.7643 48.7026 29.7413 47.9349 29.7523C47.6004 31.2833 46.6277 32.6782 45.2645 33.4635C43.7489 34.354 41.8055 34.3891 40.2164 33.6718C38.6208 32.9656 37.4155 31.4642 37.0766 29.7512C30.5919 29.7336 24.1083 29.7358 17.6236 29.7325C17.2738 31.2767 16.3043 32.6903 14.9192 33.4777C13.2698 34.4297 11.1301 34.3869 9.47851 33.4624C8.07146 32.7002 7.0669 31.292 6.74009 29.7314C5.88357 29.7369 5.02706 29.738 4.17055 29.7336C3.4906 29.7271 2.77337 29.6207 2.21296 29.2061C1.41129 28.649 0.974804 27.662 1.00112 26.698C1.00332 19.1309 0.997835 11.5637 1.00332 3.9966C0.990158 3.31884 1.18537 2.62903 1.62185 2.10262ZM3.21972 3.69939C3.16818 4.01524 3.19998 4.33767 3.1956 4.6557C3.1934 11.9289 3.19779 19.2022 3.19121 26.4754C3.1956 26.6783 3.18353 26.8844 3.22521 27.084C3.32171 27.3878 3.64633 27.5754 3.95779 27.5501C4.89107 27.5447 5.82435 27.5578 6.75763 27.5436C7.11186 25.7592 8.38512 24.1712 10.0883 23.5088C11.3911 22.977 12.9024 22.9298 14.2085 23.477C15.9172 24.1581 17.2573 25.7209 17.6159 27.5315C22.3755 27.5732 27.1363 27.5359 31.897 27.5501C31.9409 24.9609 31.9145 22.3727 31.9211 19.7834C31.9233 14.5204 31.9189 9.2585 31.9233 3.9955C31.9617 3.65224 31.7303 3.27059 31.3739 3.22124C30.9385 3.17627 30.4998 3.21466 30.0633 3.2015C21.3622 3.20479 12.6611 3.2015 3.95999 3.2026C3.64195 3.17956 3.28772 3.36819 3.21972 3.69939ZM34.1386 10.2872C34.1101 16.0437 34.1342 21.8002 34.1265 27.5567C35.1037 27.5567 36.0819 27.5534 37.0591 27.5589C37.4353 25.8744 38.5528 24.3357 40.1485 23.6251C41.5456 22.9704 43.2225 22.8936 44.6416 23.5264C46.3162 24.2305 47.5873 25.7845 47.958 27.5611C48.6851 27.5425 49.4133 27.5732 50.1393 27.5501C50.5209 27.5534 50.8214 27.1806 50.7797 26.8099C50.7797 24.4334 50.7786 22.0568 50.7797 19.6803C50.7984 19.3568 50.6569 19.0541 50.4595 18.8063C48.242 16.1578 46.0234 13.5104 43.8037 10.864C43.535 10.5197 43.1282 10.2664 42.6796 10.2883C39.8326 10.2861 36.9856 10.2894 34.1386 10.2872ZM11.6938 25.3458C10.1727 25.5487 8.90275 26.9163 8.86108 28.4582C8.66587 30.0835 9.96434 31.6539 11.5502 31.9259C12.875 32.1946 14.3237 31.5728 15.0234 30.4136C15.8886 29.114 15.5783 27.2266 14.441 26.1891C13.7172 25.5059 12.6732 25.2032 11.6938 25.3458ZM41.7057 25.416C40.3579 25.7274 39.3007 26.9579 39.179 28.3332C38.9432 30.0133 40.2614 31.6814 41.9207 31.9347C43.2718 32.1902 44.7359 31.5201 45.4071 30.3171C46.2142 29.0131 45.8655 27.1849 44.7392 26.1771C43.943 25.4313 42.7575 25.155 41.7057 25.416Z"
                fill="#FFBE00"
                stroke="#FFBE00"
                strokeWidth="0.2"
              />
            </svg> */}
          </div>
        </div>
        <div className="banner-right" style={{zIndex: 2}}>
          <a href="" className="banner-title">
            {catalogResult?.name}
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.45082 1L12.9974 6.23494L8.45082 11M13 6.18882H0.999999H13Z"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
          <div className="banner-description">
            {catalogResult?.count_sub_items} категорiй,{' '}
            {catalogResult?.count_products} товарiв
          </div>
        </div>
      </div>
      <ul className="banner-list" style={{zIndex: 2}}>
        {catalogResult?.sub_items?.map(item => (
          <Link
            key={item.id}
            to={`/product-groups/${item.parent__url_repr}/${item.url_repr}`}>
            <li>
              {item.name} <span>{item.count_products}</span>
            </li>
          </Link>
        ))}
      </ul>
    </div>
  );
};
